import { useState } from "react";
import { Check, X, Pencil } from "lucide-react";

export function Diff({ before, after }) {
  return (
    <div className="grid grid-cols-2 gap-2 text-sm">
      <div className="rounded-md bg-rose-500/5 border border-rose-500/20 p-2 text-slate-300"><div className="text-[10px] uppercase text-rose-300 mb-1">Before</div>{before}</div>
      <div className="rounded-md bg-emerald-500/5 border border-emerald-500/20 p-2 text-slate-100"><div className="text-[10px] uppercase text-emerald-300 mb-1">After</div>{after}</div>
    </div>
  );
}

const STATUS = { accepted: "text-emerald-300", edited: "text-emerald-300", rejected: "text-rose-300", rejected_by_code: "text-rose-400" };

export default function ChangeCard({ ch, onDecide, idp, children }) {
  const [edit, setEdit] = useState(false);
  const [text, setText] = useState(ch.after || ch.before);
  const pending = ch.status === "pending";
  return (
    <div className="card-surface space-y-2" data-testid={`${idp}-${ch.id}`}>
      <div className="flex items-center gap-2 text-xs">
        <span className="font-mono text-blue-300">{ch.line_id}</span><span className="text-slate-500">{ch.section}</span>
        {!pending && <span className={`ml-auto font-medium ${STATUS[ch.status]}`}>{ch.status.replace(/_/g, " ")}</span>}
      </div>
      {children}
      {edit ? (
        <textarea data-testid={`${idp}-edit-text-${ch.id}`} value={text} onChange={(e) => setText(e.target.value)} rows={3}
          className="w-full bg-slate-900 border border-blue-500 rounded-md p-2 text-sm outline-none" />
      ) : ch.delete ? (
        <div className="grid grid-cols-2 gap-2 text-sm">
          <div className="rounded-md bg-rose-500/5 border border-rose-500/20 p-2 text-slate-300 line-through">{ch.before}</div>
          <div className="rounded-md border border-rose-500/40 p-2 text-rose-300 font-medium" data-testid={`${idp}-delete-label-${ch.id}`}>Delete this line</div>
        </div>
      ) : <Diff before={ch.before} after={ch.final || ch.after} />}
      {pending && (
        <div className="flex gap-2">
          {edit ? (
            <button data-testid={`${idp}-save-edit-${ch.id}`} onClick={() => onDecide(ch, "edit", text)} className="px-3 py-1 rounded-md bg-blue-600 hover:bg-blue-500 text-xs">Save edit & apply</button>
          ) : (
            <button data-testid={`${idp}-accept-${ch.id}`} onClick={() => onDecide(ch, "accept")} className="px-3 py-1 rounded-md bg-emerald-600/80 hover:bg-emerald-500 text-xs inline-flex items-center gap-1"><Check size={12} />Accept</button>
          )}
          <button data-testid={`${idp}-edit-${ch.id}`} onClick={() => setEdit(!edit)} className="px-3 py-1 rounded-md bg-slate-800 hover:bg-slate-700 text-xs inline-flex items-center gap-1"><Pencil size={12} />{edit ? "Cancel" : ch.delete ? "Keep & edit instead" : "Edit"}</button>
          <button data-testid={`${idp}-reject-${ch.id}`} onClick={() => onDecide(ch, "reject")} className="px-3 py-1 rounded-md bg-slate-800 hover:bg-rose-600/60 text-xs inline-flex items-center gap-1"><X size={12} />Reject</button>
        </div>
      )}
    </div>
  );
}
